import React from 'react';
import './CarRental.css';

const CarRental = () => {
  const rentalCars = [
    {
      type: "Maruti Suzuki Dzire (Sedan)",
      image: "../images/Tariffs/Dzire.webp",
      capacity: "4+1",
      rent: "1600 Rs/Per Day",
      rate: "11/km",
      driverBata: "300 Rs"
    },
    {
      type: "Maruti Ertiga (MPV)",
      image: "../images/Tariffs/ertiga.webp",
      capacity: "6+1",
      rent: "2100 Rs/Per Day",
      rate: "13/km",
      driverBata: "300 Rs"
    },
    {
      type: "Chevrolet Tavera (MUV)",
      image: "../images/Tariffs/tavera.jpg",
      capacity: "9+1",
      rent: "2100 Rs/Per Day",
      rate: "13/km",
      driverBata: "300 Rs"
    },
    {
      type: "Innova Crysta (Premium Vehicle)",
      image: "../images/Tariffs/innovacrysta.webp",
      capacity: "6+1",
      rent: "2700 Rs/Per Day",
      rate: "14/km",
      driverBata: "300 Rs"
    },
    {
      type: " Tempo Traveler (14+1)",
      image: "../images/Tariffs/tempo.webp",
      capacity: "14+1",
      rent: "2800 Rs/Per Day",
      rate: "17/km",
      driverBata: "300 Rs"
    }
  ];

  return (
    <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h3 className="rental-subtitle">Let Go With Us</h3>
            <h2 className="rental-title">Our Car Tariffs</h2>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {rentalCars.map((car, index) => (
                <div key={index} className="col">
                  <div className="card h-100 text-center">
                    <img src={car.image} className="card-img-top" alt={car.type} />
                    <div className="card-body">
                      <div className="capacity-badge">{car.capacity}</div>
                      <h5 className="card-title">{car.type}</h5>
                      <p className="card-text">
                        Rent: {car.rent}
                        {car.rent2 && <><br />Rent: {car.rent2}</>}
                        {car.driverBata && <><br />Driver Bata: {car.driverBata}</>}
                      </p>
                      <p className="fw-bold text-success">Rs. {car.rate}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};

export default CarRental;
